import {
	Http
}
from '../utils/http.js'
import {
	objGetSomeKeys
} from '../utils/index'
import {
	AgencyModel
} from './agency.js'
import {
	cache
} from '@/utils/cache.js';

const agency = new AgencyModel()
class OrderModel extends Http {
	constructor() {
		super(true);
		this._storageKeyName = 'newOrder';
	}

	// 封装组装商品数组参数
	getProductsParameter(productsArr) {
		return productsArr.map(val => {
			let item = {
				product_id: val.id,
				count: val.count,
				spec_key: val.spec_key
			}
			return item
		})
	}

	getOrderPriceNeedParameter(allData, oProducts) {
		const param = ['payWay', 'buyerMsg'],
			paramNeed = objGetSomeKeys(allData, param, true)
		paramNeed['products'] = oProducts
		paramNeed['agency_id'] = agency.getId()
		return paramNeed;
	}
	// 保存缓存
	execSetStorageSync(data) {
		cache.set(this._storageKeyName, data);
	}
	// 下单
	doOrder(oParam) {
		const params = {
			url: '/order',
			method: 'post',
			data: oParam
		}
		return this.request(params)
			.then(res => {
				this.execSetStorageSync(true)
				return this._returnPromise(res)
			}, err => {
				return this._returnPromise(err)
			})
	}

	/*
	 * 拉起微信支付
	 * params:
	 * norderNumber - {int} 订单id
	 * return：
	 * callback - {obj} 回调方法 ，返回参数 可能值 0:商品缺货等原因导致订单不能支付;  1: 支付失败或者支付取消； 2:支付成功；
	 * */
	getPreOrder(orderId, callback) {
		const params = {
			url: '/pay/pre_order',
			method: 'post',
			data: {
				id: orderId
			}
		}
		return this.request(params)
	}

	getList(type = 0, start = 0, size = 4) {
		const params = {
			url: `/order/by_user?start=${start}&count=${size}`,
			data: {
				type
			}
		}
		return this.request(params)
	}

	getDetail(id) {
		const params = {
			url: `/order/${id}`

		}
		return this.request(params)
	}

	cancel(id) {
		const params = {
			url: `/order/cancel/${id}`

		}
		return this.request(params)
	}

	receive(id) {
		const params = {
			url: '/order/receive',
			data: {
				id
			},
			method: 'POST'
		}
		return this.request(params)
	}

	sendInfo(id) {
		const params = {
			url: `/order/send/${id}`
		}
		return this.request(params)
	}
	send(id, data) {
		const params = {
			url: `/order/send/${id}`,
			data,
			method: 'POST'
		}
		return this.request(params)
	}
}

export {
	OrderModel
}
